import Thumbnail from './Thumbnail'
import './searchResultCard.css'

export const searchResultCardClass =
  'flex flex-col overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-[0_1px_3px_rgba(0,0,0,0.06)] transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[0_8px_32px_rgba(91,33,182,0.12)]'

export const SearchResultMeta = ({ icon: Icon, children }) => (
  <span className="search-result-meta inline-flex items-center gap-1.5">
    <Icon className="h-3.5 w-3.5 shrink-0 text-gray-400" aria-hidden />
    {children}
  </span>
)

export const SearchResultFooter = ({ price, priceSubtext, action, className = '' }) => (
  <div
    className={`search-result-card__footer mt-auto flex items-end justify-between gap-2 pt-3 ${className}`.trim()}
  >
    <div>
      <p className="search-result-card__price m-0">{price}</p>
      {priceSubtext ? (
        <p className="search-result-card__subtext m-0 mt-0.5">{priceSubtext}</p>
      ) : null}
    </div>
    {action}
  </div>
)

const SearchResultCard = ({
  imageSrc,
  imageAlt = '',
  resolveImage = true,
  layout = 'grid',
  badge,
  topRight,
  title,
  children,
  footer,
  className = '',
}) => {
  const isList = layout === 'list'

  const media = (
    <div
      className={
        isList
          ? 'search-result-card__media relative h-40 w-full shrink-0 overflow-hidden bg-brand-50 sm:h-44 md:h-auto md:min-h-[13rem] md:w-48 lg:w-52'
          : 'relative aspect-[16/9] overflow-hidden bg-brand-50'
      }
    >
      <Thumbnail
        src={imageSrc}
        alt={imageAlt}
        className="h-full w-full"
        rounded="rounded-none"
        resolve={resolveImage}
      />
      {badge ? (
        <div className="absolute left-2 top-2 rounded-full bg-white/85 backdrop-blur">{badge}</div>
      ) : null}
      {topRight}
    </div>
  )

  const body = (
    <div
      className={`search-result-card__body flex min-w-0 flex-1 flex-col ${
        isList ? 'gap-1.5 p-3' : 'gap-2 p-4'
      }`}
    >
      {title ? (
        <h3 className="search-result-card__title line-clamp-1 m-0 font-semibold text-gray-900">{title}</h3>
      ) : null}
      {children}
      {footer}
    </div>
  )

  return (
    <article
      className={`search-result-card ${isList ? 'search-result-card--list' : ''} ${searchResultCardClass} ${className}`.trim()}
    >
      {isList ? (
        <div className="flex flex-col md:flex-row md:items-stretch">{media}{body}</div>
      ) : (
        <>
          {media}
          {body}
        </>
      )}
    </article>
  )
}

export default SearchResultCard
